<template lang="pug">
div(v-if="loaded")
  sidebar(:menuItems="menuItems")
    .app-container
      .header
        navbar(:breadcrumb="breadcrumb" :params="params")
      .content.p-relative
        router-view
      footer-app
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AuthManager from '@/lib/AuthManager'
import menuItems from '@/lib/menuItems'
import Sidebar from '@/components/menu/Siderbar'
import Navbar from '@/components/menu/Navbar'
import FooterApp from '@/components/layout/Footer'

export default {
  data() {
    return {
      loaded: false,
      breadcrumb: [],
      params: {},
      menuItems,
    }
  },

  components: { FooterApp, Sidebar, Navbar },

  computed: {
    ...mapState('user', ['currentUser']),
    ...mapState('systemParameters', ['systemParameters']),
  },

  methods: {
    ...mapActions('user', ['fetchCurrentUser']),
    ...mapActions('systemParameters', ['fetchSystemParameters']),
  },

  async created() {
    this.breadcrumb = this.$route.meta.breadcrumb || []
    this.params = this.$route.params || {}

    try {
      if (!this.currentUser) await this.fetchCurrentUser()

      if (!this.systemParameters) await this.fetchSystemParameters()
    } catch (e) {
      this.$toaster.error(e.message)
      AuthManager.logOff()
      this.$router.replace({ name: 'auth.signIn' })
    } finally {
      this.loaded = true
    }
  },

  watch: {
    async $route(newRoute) {
      this.breadcrumb = newRoute.meta.breadcrumb || []
      this.params = newRoute.params || {}
    },
  },
}
</script>

<style lang="stylus" scoped>
.app-container
  display flex
  flex-direction column
  height 100vh
  .content
    flex 1
    background-color #fff
    overflow-y auto
    overflow-x hidden
</style>
